export const Index = ()=>{
    return (
        <>Tablet Index</>
    )
}